import React from 'react';
import { AppInputLtr } from '../app-input-ltr';
import { AppInputProps } from '../app-input';

export const AppPassportNumberInput: React.FC<React.PropsWithChildren<AppInputProps>> = (props) => {
  return <AppInputLtr placeholder={'00000000'} {...props} />;
};
